import { createColumn, defaultColumns, inputTextField, relationField, booleanComponent } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Name',
    field: 'name',
    component: inputTextField({ req: true, max: 255 })
  }),
  createColumn({
    label: 'Description',
    field: 'description',
    component: inputTextField({ type: 'textarea', req: false, max: 8192 })
  }),
  createColumn({
    label: 'Also Included',
    field: 'alsoIncluded',
    component: inputTextField({ type: 'textarea', req: false, max: 8192 })
  }),
  createColumn({
    label: 'Comp/Free Event Slots',
    field: 'freeSlotCount',
    type: 'number',
    defaultValue: '0',
    component: inputTextField({ req: false, type: 'number' })
  }),
  createColumn({
    label: 'Non Member Price',
    field: 'nonMemberPrice',
    type: 'number',
    component: inputTextField({ req: false, type: 'number', money: true }),
    description: 'Fill in Non-Member price only if you wish everyone to have the same price.'
  }),
  createColumn({
    label: 'Member Price',
    field: 'memberPrice',
    type: 'number',
    component: inputTextField({ req: false, type: 'number', money: true }),
    description: 'Fill in Member price to define a special price for members.'
  }),
  createColumn({
    label: 'Event',
    field: 'event',
    section: 'Associated Event',
    // description: 'Listing of all users who have access to modify this school'
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'eventId',
      // fk: 'id',
      namespace: 'event',
      filterIs: 'text-filter',
      label: 'name'
    })
  }),
  createColumn({
    label: 'Limit Available Purchases',
    field: 'limitAmount',
    type: 'boolean',
    description: 'Leave off / false for unlimited',
    defaultValue: false,
    component: booleanComponent
  }),
  createColumn({
    label: 'Number Available',
    field: 'maxQuantity',
    type: 'number',
    component: inputTextField({ req: false, type: 'number' }),
    defaultValue: 20,
    description: 'Limit how many purchases of this sponsorship. Set to 0 to stop purchases of this Sponsorship.'
  }),
  createColumn({
    label: 'Sort Order',
    field: 'sortOrder',
    type: 'number',
    defaultValue: '0',
    component: inputTextField({ req: true, type: 'number' }),
    description: 'Numeric value that indicates from top to bottom the order of Sponsorhips.  Lower numbers on top.'
  })
].concat(defaultColumns)
